import React, { useCallback, useRef, useState } from 'react';
import { HeadsUpModal } from '../../blocks/HeadsUpModal';

type UseHeadsUpModalProps = {
	onGotIt?: () => void;
	onGoBack?: () => void;
};

export const useHeadsUpModal = ( {
	onGotIt,
	onGoBack,
}: UseHeadsUpModalProps = {} ) => {
	const [ open, setOpen ] = useState( false );
	const [ loading, setLoading ] = useState( false );
	const pendingOnGotItRef = useRef<( () => void ) | null>( null );

	const handleGoBack = useCallback( async () => {
		setLoading( true );
		try {
			await onGoBack?.();
		} finally {
			setLoading( false );
			setOpen( false );
		}
	}, [ onGoBack ] );

	const handleGotIt = useCallback( async () => {
		const callback = pendingOnGotItRef.current ?? onGotIt;
		pendingOnGotItRef.current = null;
		setLoading( true );
		try {
			await callback?.();
		} finally {
			setLoading( false );
			setOpen( false );
		}
	}, [ onGotIt ] );

	const openModal = useCallback( ( onGotItOverride?: () => void ) => {
		pendingOnGotItRef.current = onGotItOverride ?? null;
		setOpen( true );
	}, [] );

	const showIfRemindersDisabled = useCallback(
		( automatedRemindersEnabled: boolean | null | undefined ): boolean => {
			if ( automatedRemindersEnabled === false ) {
				setOpen( true );
				return true;
			}
			return false;
		},
		[]
	);

	const headsUpModalJsx = (
		<HeadsUpModal
			open={ open }
			loading={ loading }
			onGotIt={ handleGotIt }
			onGoBack={ handleGoBack }
			onClose={ () => setOpen( false ) }
		/>
	);

	return {
		openModal,
		showIfRemindersDisabled,
		headsUpModalJsx,
	};
};
